import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Heart, Quote, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { aboutMeContent, ownerPhoto } from '../data/mock';

const AboutMePage = () => {
  return (
    <section
      className="py-16 lg:py-24 min-h-screen"
      style={{
        background:
          'linear-gradient(180deg, rgba(240, 228, 240, 0.5) 0%, rgba(255, 249, 242, 1) 100%)'
      }}
    >
      <Helmet>
        <title>About Us - Meet Teaira Pannell | A Gentle Touch HomeCare Columbus, Ohio</title>
        <meta name="description" content="Learn about A Gentle Touch HomeCare founder Teaira Pannell and our mission to provide compassionate non medical home care services for seniors in Columbus, Ohio. Discover our story and commitment to quality care." />
        <link rel="canonical" href="https://agentletouchhomecare.com/about-me" />
      </Helmet>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back to Home Link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#008080] hover:text-[#006666] mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="text-center mb-10">
          <h1
            className="text-3xl sm:text-4xl font-display font-semibold mb-4"
            style={{ color: '#c49bc4' }}
          >
            {aboutMeContent.title}
          </h1>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-start">
          {/* Owner Photo */}
          <div className="lg:col-span-1">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={ownerPhoto}
                alt="Teaira Pannell - Owner of A Gentle Touch HomeCare"
                className="w-full h-auto object-cover"
              />
            </div>

            <div className="text-center mt-4">
              <h3 className="text-xl font-semibold" style={{ color: '#008080' }}>
                Teaira Pannell
              </h3>
              <p className="text-gray-600 text-sm">Owner</p>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-2">
            <div
              className="bg-white rounded-2xl p-8 shadow-lg"
              style={{ borderLeft: '5px solid #008080' }}
            >
              {/* Main content paragraphs */}
              <div className="space-y-5 text-gray-700 leading-relaxed">
                {aboutMeContent.content.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-base">
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Quote */}
              <div
                className="mt-8 p-5 rounded-xl relative"
                style={{ background: 'rgba(0, 128, 128, 0.08)' }}
              >
                <Quote
                  className="w-6 h-6 absolute top-3 left-3 opacity-30"
                  style={{ color: '#008080' }}
                />
                <p
                  className="text-lg font-display italic text-center pl-6"
                  style={{ color: '#008080' }}
                >
                  {aboutMeContent.quote}
                </p>
              </div>

              {/* Closing */}
              <div className="mt-6 text-center">
                <div className="inline-flex items-center gap-2 mb-3">
                  <Heart className="w-5 h-5" style={{ color: '#c49bc4' }} />
                </div>
                <p className="text-base font-medium text-gray-800">
                  {aboutMeContent.closing}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMePage;
